<template>
  <div>
    <label for="bookingServiceSelected"
      >Service<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingServiceSelected"
      v-model="service"
      :options="services"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { assembleDropdown } from "@/utils/dropdown";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingServiceDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    storeCode: { type: String, default: null },
  },
  data() {
    return {
      service: this.value,
      services: [],
    };
  },
  created() {
    if (this.storeCode) {
      this.getServices(this.storeCode);
    }
  },
  watch: {
    service(newValue) {
      this.$emit("setService", newValue);
    },
    value(newValue) {
      this.service = newValue;
    },
    services(newValue) {
      this.$emit("setServices", newValue);
    },
    storeCode(newStoreCode) {
      if (newStoreCode) {
        this.getServices(newStoreCode);
      } else {
        this.services = [];
      }
    },
  },
  methods: {
    async getServices(storeCode) {
      try {
        emitLoadingStart(this);
        await BookingService.getServices({ storeCode: storeCode })
          .then(async (res) => {
            this.services = assembleDropdown(await res.data.items);
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
  },
};
</script>
